import React, { useState } from 'react';
import { withStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import gmbLogo from '../../gmb-logo.svg';

const styles = {
  wrapper: {
    boxShadow: 'none',
  },
  toolbar: {
    minHeight: '64px',
    padding: '0 24px',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  logoImg: {
    height: '22px',
    width: 'auto',
    marginRight: '10px',
  },
  logoText: {
    fontWeight: 500,
    fontSize: '1.5rem',
    letterSpacing: '0.01em',
    textTransform: 'uppercase',
    color: '#21262D',
  },
  avatar: {
    height: '40px',
    width: '40px',
    cursor: 'pointer',
    marginRight: '12px',
  },
  userInfo: {
    textAlign: 'right',
  },
  userName: {
    fontWeight: 600,
    fontSize: '0.9375rem',
    lineHeight: 1.3,
    color: '#21262D',
  },
  userRole: {
    fontSize: '0.8125rem',
    opacity: 0.7,
    lineHeight: 1.3,
    color: '#21262D',
  },
};

const AppBarCustom = ({ classes }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleProfile = () => {
    navigate('/profile');
    handleClose();
  };

  const handleLogOut = () => {
    localStorage.removeItem('user');
    handleClose();
    navigate('/logout');
  };

  const getAvatarUrl = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.picture;
  };

  const user = localStorage.getItem('user');
  if (!user) {
    return null;
  }
  const { firstName = 'Unknown', lastName = 'Unknown', role = 'Unknown' } = JSON.parse(user);

  return (
    <AppBar className={classes.wrapper}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.logoLink}>
          <img src={gmbLogo} alt="GMB" className={classes.logoImg} />
          <Typography component="h1" variant="h5" className={classes.logoText}>
            Praxis
          </Typography>
        </div>
        <Box sx={{ flexGrow: 1 }} />
        <Avatar
          src={getAvatarUrl()}
          className={classes.avatar}
          aria-owns={anchorEl ? 'simple-menu' : undefined}
          onClick={handleOpen}
          aria-haspopup="true"
        />
        <div className={classes.userInfo}>
          <Typography color="inherit" className={classes.userName}>
            {firstName} {lastName}
          </Typography>
          <Typography color="inherit" className={classes.userRole}>
            {role}
          </Typography>
        </div>
      </Toolbar>
      <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleClose}>
        <MenuItem onClick={handleProfile}>My Profile</MenuItem>
        <MenuItem onClick={handleLogOut}>Logout</MenuItem>
      </Menu>
    </AppBar>
  );
};

export default withStyles(styles)(AppBarCustom);
